import { render, staticRenderFns } from "./ScrollerCustomize.vue?vue&type=template&id=775d983e&"
import script from "./ScrollerCustomize.vue?vue&type=script&lang=js&"
export * from "./ScrollerCustomize.vue?vue&type=script&lang=js&"
import style0 from "./ScrollerCustomize.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports